module.exports = __webpack_public_path__ + "static/media/arya_kulkarni.acfee9c0.png";